import { useContext } from "react";
import { SavingsCalculatorContext } from "../context";
import { efficiencyUnit, priceUnit } from "../utils/format";

const useCurrentVehicleData = () => {
    const [state, setState] = useContext(SavingsCalculatorContext);

    const current = state.currentVehicle;

    const getFuelType = () => current.fuelType;
    const getEfficiency = () => current.efficiency;
    const getAnnualKm = () => current.annualKm;

    // Precio de referencia (solo lectura) según el combustible seleccionado.
    const getReferencePrice = () => {
        const price = (state.fuelPrices || {})[current.fuelType];
        return price != null ? price : 0;
    };

    const getEfficiencyUnit = () => efficiencyUnit(current.fuelType);
    const getPriceUnit = () => priceUnit(current.fuelType);

    const setFuelType = (fuelType) => {
        setState((prev) => ({
            ...prev,
            currentVehicle: { ...prev.currentVehicle, fuelType },
        }));
    };

    const setEfficiency = (efficiency) => {
        setState((prev) => ({
            ...prev,
            currentVehicle: { ...prev.currentVehicle, efficiency },
        }));
    };

    const setAnnualKm = (annualKm) => {
        setState((prev) => ({
            ...prev,
            currentVehicle: { ...prev.currentVehicle, annualKm },
        }));
    };

    return {
        getFuelType,
        getEfficiency,
        getAnnualKm,
        getReferencePrice,
        getEfficiencyUnit,
        getPriceUnit,
        setFuelType,
        setEfficiency,
        setAnnualKm,
    };
};

export default useCurrentVehicleData;
